import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16 flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-500 mb-5">
            <i className="ri-error-warning-line text-3xl"></i>
          </div>
          <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-2">404 - 页面未找到</h1>
          <p className="text-foreground-500 text-sm mb-8">您访问的页面不存在或已被移除</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/category/latest-address"
              className="px-6 py-2.5 rounded-lg border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看最新地址
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}